/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { addStoreByShopifyApp } from "../../api/store";
import { getLoggedUser, logoutUser } from "../../redux/slices/authSlice";
import {
  storeSelector,
} from "../../redux/slices/storeSlice";
import { isClientPreview } from "../../utils/clientPreview";
import ConnectingStore from "../../components/welcome/ConnectingStore";

export default function ShopifyAppInstall() {
  const location = useLocation();
  const findShop = new URLSearchParams(location.search);
  const shopifyStore = findShop.get("shop");

  const dispatch = useDispatch();
  const { shopifyAppStore } = useSelector(storeSelector);
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    // ?demo=1 in the client preview only shows the screen and then walks on to the
    // account step; it connects nothing.
    if (isClientPreview() && findShop.get("demo")) {
      setTimeout(() => window.location.assign("/set-password-store-owner?demo=1"), 3200);
      return;
    }
    if (
      shopifyStore !== null ||
      shopifyStore !== undefined ||
      shopifyStore !== ""
    ) {
      dispatch(
        addStoreByShopifyApp({
          store_name: shopifyStore,
          queries: location.search,
        })
      );
    }
  }, [shopifyStore]);



  useEffect(() => {
    if (shopifyAppStore?.storeId) {
      localStorage.setItem("active_store", shopifyAppStore?.storeId);
    }
    if (shopifyAppStore?.store) {
      // dispatch(logoutUser());
      window.location.href = shopifyAppStore.store;
    }
    if (shopifyAppStore?.type === "set_logged_in") {
      dispatch(getLoggedUser(shopifyAppStore));
      localStorage.setItem("loggedUser", JSON.stringify(shopifyAppStore));
      window.location.href = "/customer/dashboard";
    }
    if (shopifyAppStore?.type === "set_password") {
      window.location.href = "/set-password-store-owner";
    }
  }, [shopifyAppStore]);

  if (isClientPreview()) {
    return <ConnectingStore shop={shopifyStore || (findShop.get("demo") ? "your-store.myshopify.com" : "")} />;
  }

  return (
    <div
      style={{ width: "100%", height: "100vh", background: "#3498db" }}
    ></div>
  );
}
